"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UserBadge_1 = require("./UserBadge");
exports.default = UserBadge_1.default;
//# sourceMappingURL=index.js.map